import { Injectable } from "@angular/core";
import {
  ActivatedRoute,

} from "@angular/router";
import { BehaviorSubject, Observable, of } from "rxjs";
import {

  filter,
  map,
  mergeMap,
  tap
} from "rxjs/operators";
import {

  ViewDataService,
  WaHelperService,

} from "world-archery-lib";
import { FiltersAbstractService } from 'src/app/common-page-components/classes/filters-abstract-service';
import { TextFilter, ComboStoreComponent } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: "root"
})
export class FiltersSeriesTeamsService extends FiltersAbstractService {
  textSearch = new TextFilter('indoorteamseriestext', undefined, undefined, 'search');
  categoriesCombo = new ComboStoreComponent('Categories:', 'Name', 'indoorteamseriescategory',
    undefined, undefined, this.http, 'WORLDCUPRANKINGSCATEGORIES', [], [], true, 'category_team');
  yearCombo = new ComboStoreComponent('Year:', 'Year', 'indoorteamseriesyear',
    undefined, undefined, this.http, 'SERIES', [], [], true, 'year');
  filtersType: any = [
    this.textSearch.filterInfo,
    this.categoriesCombo.filterInfo,
    this.yearCombo.filterInfo
  ];

  protected textSubject: BehaviorSubject<string> = new BehaviorSubject('');
  constructor(
    protected views: ViewDataService,
    protected helper: WaHelperService,
    private http: HttpClient,
    private route: ActivatedRoute
  ) {
    super();
    this.generateDefaultValues();
    // this.sortLocator.asc = true;
  }
  generateDefaultValues() {
    this.yearCombo.filterInfo.options.initial_state = true;
    this.yearCombo.requestData({ 'DisciplineId': 2, 'RBP': 'ALL' }, false).pipe(
      map(a => a.items),
      mergeMap(
        next => {
          let comboSeason = [];

          let index = next.findIndex(
            value => value.discipline === 2
          );
          let selected = comboSeason[index];
          comboSeason = next.filter(value => value.Year >= 2019 && value.Discipline === 2);
          if(this.route.snapshot.queryParams['year']){
            index = comboSeason.findIndex(value => value.Year.toString() === this.route.snapshot.queryParams['year']);
            if(index > -1){
              selected = comboSeason[index];
            }
          }else{
            selected = WaHelperService.getComboSeasonItemByCurrentYear(comboSeason);
          }
          this.filtersType[2].options.options_subject.next(comboSeason);
          this.filtersType[2].options.options_selected_subject.next(selected);
          return of(next);
        }
      )).subscribe();

    this.filtersType[2].options.options_selected_subject.asObservable().pipe(
      filter((a: any) => a && a.Year != undefined),
      mergeMap((a: any) => {

        return this.categoriesCombo.requestData({ 'DisciplineId': 2, 'RBP': 'ALL', 'Year': a.Year }, false)
          .pipe(
            map(a => a.items),
            map((data: Array<any>) =>
              data.filter(value => value.Team === true)
            ),
            tap(next => {
              next.forEach(value => {
                value.name = value.Name
                  ? value.Name
                  : this.helper.getCategoryInfoByCode(value.Cat).name;
              });
              this.filtersType[1].options.options_subject.next(next);
              this.filtersType[1].options.options_selected_subject.next(next[0]);
            })
          )
      })
    ).subscribe();
  }

  getDataStreamWithFilters(): Observable<any> {
    return;
  }
}
